const arraysEqual = (a: string[], b: string[]) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (const [i, element] of a.entries()) {
    if (element !== b[i]) return false;
  }
  return true;
};

export default arraysEqual;
